export default __webpack_public_path__ + "static/media/cil-data-transfer-down.ab1f7650.svg";